<template>
	<div class="project-event-list">
		<AppLazyLoaderComponentFromMonolith
			:params="params"
			:container="Monolith.LAZY_CONTAINER.PROJECT_EVENT_LIST"
		/>
	</div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { Monolith } from '@/constants/monolith';
import { AppLazyLoaderComponentFromMonolith } from '@/features/App';
import { useProjectDetailsViewStore } from '@/features/Project';
import { type RetainerPeriod, type Project } from '@/generated/graphql';

const props = defineProps<{
	projectId: Project['id'];
	retainerPeriodId?: RetainerPeriod['id'];
}>();

const projectDetailsViewStore = useProjectDetailsViewStore();

const params = computed(() => ({
	retainerPeriodId: props.retainerPeriodId,
	updateCounter: projectDetailsViewStore.calendarUpdateCounter,
	eventListFilters: projectDetailsViewStore.projectTabsEventListFilters,
	appendCssToHtml: 1,
}));
</script>

<style lang="scss">
.project-event-list {
	.legend {
		margin: 1rem 0;
	}
}
</style>
